import {ChallengeBuilderAction, ChallengeBuilderActionType} from './challenge-builder.action';
import {ChallengeBuilderState, initialChallengeBuilderState} from './challenge-builder.state';

export function challengeBuilderReducer(
  state: ChallengeBuilderState = initialChallengeBuilderState,
  action: ChallengeBuilderAction
): ChallengeBuilderState {
  switch (action.type) {
    case ChallengeBuilderActionType.SET_CHALLENGE_BUILDER_LOADING:
      return {...state, loading: action.payload.loading};
    case ChallengeBuilderActionType.UPDATE_CHALLENGE_BUILDER_PROJECT:
      return {...state, cbProject: action.payload.cbProject};
    case ChallengeBuilderActionType.SET_NEXT_LOADING:
      return {...state, nextLoading: action.payload.nextLoading};
    case ChallengeBuilderActionType.SET_BACK_LOADING:
      return {...state, backLoading: action.payload.backLoading};
    case ChallengeBuilderActionType.UPDATE_CHALLENGE_NEXT_VALID:
      return {...state, challengeNextValid: action.payload.valid};
    case ChallengeBuilderActionType.CLEAR:
      return {
        cbProject: null,
        loading: false,
        nextLoading: false,
        backLoading: false,
        challengeNextValid: false,
        prompts: [],
      };
    case ChallengeBuilderActionType.SET_CHALLENGE_BUILDER_PROMPTS:
      return {...state, prompts: action.payload.prompts};
    default:
      return state;
  }
}
